import React from "react";
// The nav glyphs are the design team's own SVGs, pulled in as components so a
// className can size them. They already draw in the sidebar ink (#00424B), so
// nothing that uses them has to recolour them.
import { ReactComponent as DashboardIcon } from "../../assets/svg/sidebar/dashboard.svg";
import { ReactComponent as UsersIcon } from "../../assets/svg/sidebar/clients-active.svg";
import { ReactComponent as RevenueIcon } from "../../assets/svg/sidebar/revenue.svg";
import { ReactComponent as SettingsIcon } from "../../assets/svg/sidebar/settings.svg";
import { ROUTES } from "../../routes/paths";

export type NavIcon = React.FC<React.SVGProps<SVGSVGElement>>;

/**
 * The glyph each sidebar destination is known by, keyed by its route. Kept
 * here rather than in the rail so a destination is known by the same icon
 * wherever it is drawn — one mapping, so the two cannot drift apart.
 */
export const NAV_ICONS: Record<string, NavIcon> = {
  [ROUTES.dashboard]: DashboardIcon,
  [ROUTES.users]: UsersIcon,
  [ROUTES.revenue]: RevenueIcon,
  [ROUTES.settings]: SettingsIcon,
};
